






















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface, TextField } from '@/components/atoms';
import CustomersIcon from '@/components/icons/Customers.vue';

import { pluralize } from '@/utils';
import DatePicker from '@/components/DatePicker/DatePicker.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import { ESpecialOfferRules } from '@/models/offer';
import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';

@Component({
  components: {
    Typography,
    Surface,
    SelectionBox,
    TextField,
    CustomersIcon,
    DatePicker,
    SpecialCoinIcon
  }
})
export default class RulesSpecialCoin extends Vue {
  @Prop({ default: [] }) readonly error!: any[];
  @Prop() readonly initialForm?: any;
  @Prop({ default: false }) readonly isHappyHour!: boolean;

  ESpecialOfferRules = ESpecialOfferRules;

  form = this.initialForm || {
    [ESpecialOfferRules.SUPPLY_RULE]: { enabled: false, value: '' },
    [ESpecialOfferRules.EXPIRATION_RULE]: { enabled: false, value: '' },
    [ESpecialOfferRules.COMBINED_RULE]: { enabled: true }
  };

  pluralize = pluralize;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'offers.form';
  }

  toggleNewCustomers(flag: { id: string; state: boolean }) {
    this.$emit('toggleNewCustomers', flag.state);
  }

  changeRule(type: ESpecialOfferRules) {
    this.changeForm();
    this.$emit('clearError', type);

    const focusMapper: Record<string, any> = {
      [ESpecialOfferRules.SUPPLY_RULE]: () => {
        if (!this.form[type].enabled) return;
        const supplyRule = this.$refs.supplyRule as any;

        supplyRule.$refs.input.focus();
      },
      [ESpecialOfferRules.EXPIRATION_RULE]: () => {
        const expirationRule = this.$refs.expirationRule as any;

        if (this.form[type].enabled) {
          expirationRule.$refs.date.openDatepicker();
        } else {
          expirationRule.$refs.date.closeDatepicker();
        }
      },
      [ESpecialOfferRules.LIMIT_RULE]: () => {
        this.$emit('clearError', ESpecialOfferRules.RENEWED_RULE);
        if (!this.form[type].value) this.form[type].value = '1';
        this.form[ESpecialOfferRules.RENEWED_RULE].enabled = this.form[
          type
        ].enabled;
        if (!this.form[type].enabled) return;
        const limitRule = this.$refs.limitRule as any;

        if (limitRule) limitRule.$refs.input.focus();
      }
    };

    if (!focusMapper[type]) return;

    focusMapper[type]();
  }

  changeDate(value: string) {
    this.form[ESpecialOfferRules.EXPIRATION_RULE].value = value;
    this.changeTextField(ESpecialOfferRules.EXPIRATION_RULE);
  }

  changeForm(firstLoad?: boolean) {
    this.$emit('input', this.form, firstLoad);
  }

  changeTextField(type: string) {
    this.$emit('clearError', type);
    this.changeForm();
  }

  created() {
    this.form[ESpecialOfferRules.COMBINED_RULE].enabled = true;
    this.changeForm(true);
  }
}
